import React, { useEffect, useState } from 'react'
import { Avatar,Tooltip,Input, message,Select , Table,Tag,Button,Modal,Image, Popover,Steps, Popconfirm, Form } from 'antd';
import axios from 'axios';
import { SERVER_ADDRESS } from '../../Config/Config';
import { SyncOutlined,UserOutlined,EyeOutlined,SearchOutlined } from '@ant-design/icons';
import { LoadingOutlined, AppleFilled,AndroidFilled } from '@ant-design/icons';
import { FaBan } from 'react-icons/fa';
import { PiRecycleDuotone } from 'react-icons/pi';
import { GrPowerReset } from "react-icons/gr";
const {TextArea} = Input

const UserList = () => {
    const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    const userPermission = userData.privelege || []
    const [users,setUser] = useState([]);
    const [filteredUser,setFilteredUser] = useState([]);
    const [loading,setLoading] = useState(true)
    const [isModalOpen,setIsmodalOpen] = useState(false)
    const [modalData,setModalData] = useState({})
    const [imageOnly,setImageOnly] = useState(false);
    const [searchTerm,setSearchTerm] = useState('');
    const [gender,setGender] = useState(null);
    const [accountStatus, setAccountStatus] = useState(null);
    const [verificationStatus, setVerificationStatus] = useState(null);
    const [deletedStatus, setDeletedStatus] = useState(null);
    const [bannedStatus, setBannedStatus] = useState(null);
    const [suspendModal,setSuspendModal] = useState(false);
    const [selectedId,setSelectedId] = useState(null);

    const [susForm] = Form.useForm();

    const showModal = async(id,imageOnly=false) => {
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/singleUser`,{
                userId:id
            })
            if(response.status===200){
                setModalData(response.data.data);
                setIsmodalOpen(true);
                setImageOnly(imageOnly)
            }
        } catch (error) {
            message.error({content:"Something went wrong !",duration:2})
        }
    };
      
    const handleOk = () => {
        setIsmodalOpen(false);
      };
      
    const handleCancel = () => {
        setIsmodalOpen(false);
      };

    const handleSuspendClose = ()=>{
        setSuspendModal(false)
        susForm.resetFields();
    }

    const fetchallUsers = async()=>{
        try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/getAllusers`);
            setUser(response.data.data)
            setFilteredUser(response.data.data)
            setLoading(false)
        } catch (error) {
            console.log(error)
            message.error({content:"Something Went Wrong !",duration:2})
            setLoading(false)
        }
        finally{
            setLoading(false)
        }
    }

    const handleSuspend = async(values)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/suspendAccount`,{
                id:selectedId,
                suspend_reason:values.suspend_reason,
                type:1
            });
            const result = response.data
            if(result.result === 1){
                const updatedUsers = filteredUser.map(user=>user.id === selectedId ? {...user,is_suspend:1} : user)
                setFilteredUser(updatedUsers)
                handleSuspendClose();
                message.success({content:"Account Suspended"})
            }
        } catch (error) {
            console.log(error)
            message.error({content:"Something Went Wrong"})
        }
    }

    const handleDisSuspend = async(id)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/suspendAccount`,{
                id,suspend_reason:"",type:2   
            })
            if(response.status === 200){
                const updatedUsers = filteredUser.map(user=>user.id === id ? {...user,is_suspend:0} : user)
                setFilteredUser(updatedUsers)
                message.success({content:"Account unbanned"})
            }
        } catch (error) {
            message.error({content:"Something wenet wrong"})
        }
    }

    useEffect(()=>{
        fetchallUsers();
    },[])

    const dobToAge = (dob)=>{
        const now = Date.now();
        const difference = now - dob;
        const age = difference / (1000 * 60 * 60 * 24 * 365.25)
        return Math.floor(age)
    }

    const formattedDate = (time) => {
        let date = new Date(parseInt(time))
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        let day = String(date.getDate()).padStart(2, '0');

        return `${day}/${month}/${year}`
    };

    useEffect(()=>{
        applyFilters();
    },[searchTerm,gender, accountStatus, verificationStatus, deletedStatus,bannedStatus])

    const applyFilters = () => {
        let filtered = users;
        if(searchTerm===''){
            setFilteredUser(users)
        }
        else if (searchTerm) {
            filtered = filtered.filter((user) =>
                user.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        
        if (gender !== null) {
            filtered = filtered.filter((user) => user.gender == gender);
        }
    
        if (accountStatus !== null) {
            filtered = filtered.filter((user) =>user.is_premium === accountStatus);
        }
    
        if (verificationStatus !== null) {
            filtered = filtered.filter((user) => user.is_verified === verificationStatus);
        }
    
        if (deletedStatus !== null) {
            filtered = filtered.filter((user) => user.is_delete === deletedStatus);
        }

        if (bannedStatus !== null) {
            filtered = filtered.filter((user) => user.is_suspend === bannedStatus);
        }
    
        setFilteredUser(filtered);
    };

    const handleFilterReset = () =>{
        setSearchTerm('');
        setGender(null);
        setAccountStatus(null);
        setVerificationStatus(null);
        setVerificationStatus(null)
        setDeletedStatus(null)
        setBannedStatus(null)
        setFilteredUser(users)
        message.success({content:"Filters Reseted",duration:0.6})
    }

    const columns = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id", 
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Profile",
            key:"profile",
            render:(_,record)=>{
                if(record.profile){
                    return  (
                        <Popover placement='top' content="Tap to view all photos" >
                            <Avatar style={{cursor:'pointer'}} size={64} src={record.profile} onClick={()=>showModal(record.id,true)} />
                        </Popover>
                    )
                }
                else{
                   return <Avatar size={64} icon={<UserOutlined />} />
                }
            }
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name", 
            render:(text)=>{
                const displayText = text.length >10 ? `${text.slice(0,10)}...`:text;
                return text.length >10 ? (
                    <Tooltip title={text} >{displayText}</Tooltip>
                ):
                (
                    <span>{text}</span>
                )
            },
            sorter:(a,b)=>a.name.localeCompare(b.name)
        },
        {
            title: "Gender",
            key: "gender", 
            render:(_,record)=>record.gender === '1' ? (<Tag color="blue" >Groom</Tag>) : (<Tag color="magenta" >Bride</Tag>) 
        },
        {
            title: "State",
            key: "state", 
            render: (_, record) => {
                const text = `${record.city || ''}, ${record.state || ''}`;
                const displayText = text.length > 10 ? text.slice(0, 10) + '...' : text;
        
                return text.length > 10 ? (
                    <Tooltip title={text}>
                        <span>{displayText}</span>
                    </Tooltip>
                ) : (
                    <span>{displayText}</span>
                );
            }
        },        
        {
            title: "Account",
            key: "is_premium", 
            render:(_,record)=>record.is_premium===1 ? (<Tag color="warning">Premium</Tag>) : (<Tag color="default">Normal</Tag>)
        },
        {
            title: "Verification Status",
            key: "is_premium", 
            render:(_,record)=>{
                if(record.is_verified === 0){
                    return <Tag color='error'>Not Verified</Tag>
                }
                else if(record.is_verified === 1){
                    
                    return (<Tag icon={<SyncOutlined spin />} color='processing'>Under Verification</Tag>)
                    
                }
                else if(record.is_verified === 2){
                    return <Tag color='success'>Verified</Tag>
                }
            }
        },
        {
            title: "Status",
            key: "is_delete",
            render:(_,record)=>record.is_delete===1 ? (<Tag color="warning">Deleted</Tag>) : (<Tag color="success">Not Deleted</Tag>) 
        },
        {
            title: "Option",
            key: "option", 
            render:(_,record)=>{
                return ( 
                    <>
                    <div className='d-flex flex-row gap-2' >
                    <Tooltip title='View User Details' ><Button color ='primary' variant='filled' onClick={()=>showModal(record.id,false)} ><EyeOutlined /></Button></Tooltip>
                    {userPermission.includes("suspend") && (<div>
                        {record.is_suspend === 1 ? <Tooltip title='Un Ban Account' ><Popconfirm title='Are You Sure want to un ban this account ?' placement='left'onConfirm={()=>handleDisSuspend(record.id)} ><Button color='cyan' variant='filled' ><PiRecycleDuotone /></Button></Popconfirm></Tooltip> : <Tooltip title='Ban Account' ><Button color='danger' onClick={()=>{setSuspendModal(true);setSelectedId(record.id)}} variant='filled' ><FaBan /></Button></Tooltip>}
                    </div>) }
                    </div>
                    </>
                )
            }
        },
      ];

    const genderOption = [{
        value:1,
        label:'Groom'
    },
    {
        value:2,
        label:'Bride'
    }]

    const accountType = [{
        value:0,
        label:'Normal'    
    },{
        value:1,
        label:'Premium'    
    }]

    const verification = [{
        value:0,
        label:'Not Verified'
    },{
        value:1,
        label:"Under Verification"
    },{
        value:2,
        label:'Verified'
    }]

    const deleted = [{
        value:0,
        label:"Not Deleted"
    },{
        value:1,
        label:'Deleted'
    }]

    const banned = [{
        value:0,
        label:"Un Banned"
    },{
        value:1,
        label:'Banned'
    }]

  return (
    <>
    <div style={{marginTop:'4rem'}} >
        <div className='d-flex flex-row justify-content-between' >
        <h2>User List</h2>
        </div>
        <div className='d-flex flex-row gap-3 mb-4' >
            <div className='' >
                <Input placeholder='Search By Name' onChange={(e)=>setSearchTerm(e.target.value)} prefix={<SearchOutlined />} value={searchTerm} />
            </div>
            <div className='' >
                <Select value={gender} style={{width:'8rem'}} onChange={(e)=>setGender(e)} placeholder={'Select Gender'} 
              options={genderOption} />
            </div>
            <div className='' >
                <Select value={accountStatus} style={{width:'8rem'}} onChange={(e)=>setAccountStatus(e)} placeholder={'Select Account Type'} 
              options={accountType} />
            </div>
            <div className='' >
                <Select value={verificationStatus}  style={{width:'8rem'}} onChange={(e)=>setVerificationStatus(e)} placeholder={'Select Verification'} 
              options={verification} />
            </div>
            <div className='' >
                <Select value={deletedStatus} style={{width:'8rem'}} onChange={(e)=>setDeletedStatus(e)} placeholder={'Select Status'} 
             options={deleted} />
            </div>
            <div className='' >
                <Select value={bannedStatus} style={{width:'8rem'}} onChange={(e)=>setBannedStatus(e)} placeholder={'Select Status'} 
             options={banned} />
            </div>
            <div>
                <Tooltip title='Reset Filters' onClick={()=>handleFilterReset()} ><Button color='blue' variant='filled' ><GrPowerReset /></Button></Tooltip>
            </div>
        </div>
        <div> 
            <Table dataSource={filteredUser} rowKey={"id"} loading={loading} columns={columns} />
        </div>
        <Modal title={imageOnly ? `${modalData.name} Photos` : `${modalData.name} Details`} width={imageOnly ? 1200 : 700} open={isModalOpen} onCancel={handleCancel}  footer={false} >
            {imageOnly ? (
                <div style={{display:'flex',flexWrap:'wrap',gap:'2rem',justifyContent:'center'}} >
                    <Image.PreviewGroup>
                        {modalData.photo && modalData.photo.map((p,index)=>(
                            <div key={index} style={{textAlign:'center'}} >
                                <div style={{alignItems:'center',display:'flex',height:300,background:'black'}} >
                                <Image src={p} width={200}  />
                                </div>
                                <p style={{marginTop:'5px',fontWeight:'bold'}}>{index + 1}</p>
                            </div>
                        ))}
                    </Image.PreviewGroup>
                </div>
            ):(
                <>
                    <Steps
                        items={[
                            {
                            title: "Aadhar Uploaded",
                            status: modalData.is_verified === 0 ? "process" : "finish",
                            },
                            {
                            title: "Under Verification",
                            status: modalData.is_verified === 1 ? "process" : modalData.is_verified < 1 ? "wait" : "finish",
                            icon: modalData.is_verified === 1 ? <LoadingOutlined /> : null,
                            },
                            {
                            title: "Verified",
                            status: modalData.is_verified === 2 ? "finish" : "wait",
                            },
                        ]}
                        />

                    <div style={{display:'flex',flexDirection:'row',gap:'3rem',padding:'3rem',fontFamily:'sans-serif',fontWeight:'600',fontSize:'15px'}} >
                        <div style={{display:'flex',flexDirection:'column'}} >
                        <p>Id</p>
                        <p>Name</p>
                        <p>Gender</p>
                        <p>DOB</p>
                        <p>Email</p>
                        <p>Phone</p>
                        <p>Device Type</p>
                        <p>Account Status</p>
                        <p>Deletion Status</p>
                        </div>
                        <div style={{display:'flex',flexDirection:'column'}} >
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        <p>:</p>
                        </div>
                        <div >
                        <p className='text-xl' >{modalData.id}</p>
                        <p >{modalData.name}</p>
                        {modalData.gender === "1" ? (<Tag style={{marginBottom:'1rem'}} color='blue'>Groom</Tag>) : (<Tag style={{marginBottom:'1rem'}} color='magenta' >Bride</Tag>)}
                        <p >{formattedDate(modalData.dob)} / <span style={{fontWeight:400,color:'gray'}} >Age : {dobToAge(modalData.dob)}</span> </p>
                        <p >{modalData.email}</p>
                        <p >{modalData.phone}</p>
                        <p >{modalData.device_type === 'Android' ? (<> <AndroidFilled /></>) :  <> <AppleFilled /> </> }</p>
                        <p >{modalData.is_active === 1 ? 'Active' : 'Not Active'}</p>
                        <p >{modalData.is_delete === 1 ? 'Deleted' : 'Not Deleted' }</p>
                        </div>
                    </div>
                </>
            )}
        </Modal>
        <Modal title='Suspend Account' open={suspendModal} onCancel={handleSuspendClose} footer={false} >
            <Form form={susForm} onFinish={handleSuspend} >
                <Form.Item name='suspend_reason' rules={[{required:"true",message:"Enter Suspend Description"},{pattern:/^(?:\s*\S){10,}.*$/,message:"Must be atleast 10 characters"}]}  >
                    <TextArea placeholder="Enter Details about suspend" rows={4}  />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 9 }} >
                    <Button type='primary' htmlType='submit' >
                        Suspend
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>
    </>
  )
}

export default UserList